@if (form) {
    <div [formGroup]="form" fxLayout="column" fxLayoutAlign="start start">
        @if (label) {
            <div class="t5 c-primary-gray-600">{{ label | translate }}</div>
        }
        <mat-form-field class="h-40 w-100"
                        [class.mt-4]="label"
                        [ngStyle]="hasDynamicWidth ? {'min-width': form.value.minWidth} : undefined"
                        [formGroup]="form"
                        [class.value-not-empty]="!isDisabled && form.value.formattedValue">
            <input matInput
                   readonly
                   formControlName="formattedValue"
                   [placeholder]="'i18n_af_placeholderSelectRange' | translate"
                   (click)="openPicker()"/>
            @if (iconPosition === 'right') {
                <ui-kit-svg matSuffix matRipple class="i-16 circle pointer p-8 mr-8 c-primary-gray-600" name="ic_calendar"
                            [class.c-primary-gray-400]="isDisabled"
                            [class.c-primary-gray-900]="!isDisabled"
                            (click)="!isDisabled && openPicker()">
                </ui-kit-svg>
            }
            @if (iconPosition === 'left') {
                <ui-kit-svg matPrefix matRipple class="i-16 circle pointer p-8 ml-8" name="ic_calendar"
                            [class.c-primary-gray-400]="isDisabled"
                            [class.c-primary-gray-900]="!isDisabled"
                            (click)="!isDisabled && openPicker()">
                </ui-kit-svg>
            }
            <ui-kit-calendar #picker
                             mode="date-range-picker"
                             [showPickerActions]="hasPickerActions"
                             (closed)="selectDate(); closePickerListener.emit()"
                             [minDate]="minDate"
                             [headerConfig]="headerConfig"
                             [maxDate]="maxDate"
                             [dateStartControl]="form.controls.dateFrom"
                             [dateEndControl]="form.controls.dateTo"
                             (openClickListener)="openPicker()">
                @if (hasPickerActions) {
                    <div PickerActions fxLayout="column" fxLayoutAlign="start center" class="w-100">
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100 mt-16">
                            <div class="t2 c-primary-gray-900">{{ 'i18n_af_labelTime' | translate }}:</div>
                            <div fxLayout="row" fxLayoutAlign="end center">
                                <mat-form-field class="time-input-max-width">
                                    <input matInput formControlName="timeFrom"
                                           [showMaskTyped]="true"
                                           [dropSpecialCharacters]="false"
                                           [leadZeroDateTime]="true"
                                           mask="Hh:m0">
                                </mat-form-field>
                                <div class="ml-8 mr-8">-</div>
                                <mat-form-field class="time-input-max-width">
                                    <input matInput formControlName="timeTo"
                                           [showMaskTyped]="true"
                                           [dropSpecialCharacters]="false"
                                           [leadZeroDateTime]="true"
                                           mask="Hh:m0">
                                </mat-form-field>
                            </div>
                        </div>
                        <mat-error
                            class="c-secondary-red-900 t3 mt-4" fxFlexAlign="end">
                            {{ (form.controls.timeTo?.hasError('invalidRange') ? 'i18n_af_fieldValidationWrongTime' : '') | translate }}
                        </mat-error>
                        <ui-kit-button [type]="'text'"
                                       [label]="'i18n_af_buttonOk'  | translate"
                                       fxFlex
                                       [disabled]="this.form.invalid"
                                       (clickListener)="selectDate()">
                        </ui-kit-button>
                    </div>
                }
            </ui-kit-calendar>
        </mat-form-field>
    </div>
}
